<!-- <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;" class="card-grid-border">
    <mat-card-header>
       
    </mat-card-header>    
    <mat-card-content>
         <div style="margin-top:20px;margin-left:10px;">
                @if(currentPARCSelected == 'AMANO ONE'){
                 <app-amano-edit-parker></app-amano-edit-parker>
                }
            </div>
</mat-card-content>
<mat-card-actions style="margin-top:20px;">
</mat-card-actions>
</mat-card> -->

@if(currentPARCSelected == 'AMANO ONE'){
    <app-amano-one-parker-settings [parkerDetail]="_parkerDetail"></app-amano-one-parker-settings> 
}
@else if(currentPARCSelected == 'FLASH'){
    <br /><strong>Todo:  Add Flash PARCS Admin Settings - maintenance here  </strong>   
}


            